import Paper from '@material-ui/core/Paper';
import React from 'react';
import { Component } from '../../../client';
import { translate } from '../../../l10n';

class TeamsEmptyPlaceholder extends Component {
   constructor(props) {
      super(props);
   }

   render() {
      return (
         <div className={'TeamsEmptyPlaceholder'}>
            <Paper className={'info-box'} elevation={3}>
               <h2 className='heading'>{translate('teams.empty.title')}</h2>

               <div style={{ textAlign: 'center' }}>{translate('teams.empty.body')}</div>
               <p>
                  {translate('teams.empty.callToActionPrefix')}
                  <b> {translate('teams.empty.callToActionButtonName')} </b>
                  {translate('teams.empty.callToActionSuffix')}
               </p>
            </Paper>
         </div>
      );
   }
}

export default TeamsEmptyPlaceholder;
